import { Box, Flex, Link, Text } from '@chakra-ui/react';
import { CustomAlertTriangleIcon } from '../../theme/icons/CustomAlertTriangleIcon';

const NfcPlatformNotice = () => (
  <Flex
    align="center"
    gap={4}
    px="14px"
    py="10px"
    mt={2}
    bg="rgba(255, 204, 0, 0.2)"
    borderRadius="5px"
    color="rgba(0, 0, 0, 0.8)"
    fontSize="15px"
    lineHeight="1.5"
    letterSpacing="-0.165px"
  >
    <CustomAlertTriangleIcon
      w="23px"
      h="21px"
      color="#FFCC00"
      flexShrink={0}
      aria-hidden="true"
    />
    <Box minW={0}>
      <Text fontWeight="semibold">NFC enabled for Google passes only.</Text>
      <Text>
        Apple NFC requires approval.{' '}
        <Link
          href="https://docs.passentry.com/documentation/guides/nfc-passes/guide"
          isExternal
          color="linkBlue"
          _hover={{ textDecoration: 'underline' }}
        >
          Find out more →
        </Link>
      </Text>
    </Box>
  </Flex>
);

export default NfcPlatformNotice;
